/**
 * 用户组菜单管理模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const userGroupMenu = {
  //得到指定临时token人员的基本信息
  list(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/rolemenu`, { params: params});
    },
  //修改指定角色的菜单
  update(params,roleid) {
    return axios.post(`${Vue.prototype.$base.API_PATH}/rolemenu/`+roleid+`/update`, params);
  },
}

export default userGroupMenu;



// WEBPACK FOOTER //
// ./src/api/userGroupMenu.js